<template>
  <div class="bangdan">
    <div class="bdtop">
      <!-- 标题 -->
      <div class="bangdantit2">
        <img src="../assets/Course.png" alt="###" class="img1" /> <br />
        <img class="img2" src="../assets/bangdanlogo.png" alt="###" />
        <h1>投票榜单</h1>
      </div>
    </div>
    <!-- 投票 card -->
        <div class="listcont2">
<el-carousel indicator-position="none"  :interval="2000" type="card" :autoplay='true' >
    <el-carousel-item  v-for="(item, index) in bangdandata"
        :key="item.id">

      <div

        class="kelist2"
      >
        <div @click="bdwk(index)" class="bangdan-img">
          <img
            :src="'http://ke.yunlearning.com:8081' + bangdandata[index].cover_img"
            alt="###"
          />
        </div>

        <p class="listp">{{ bangdandata[index].title }}</p>
        <span class="sp12">作品编号：A{{ bangdandata[index].number }}</span>
        <img class="toup2" src="../assets/toupiao.png" alt="###" />
        <span class="sp22">{{ bangdandata[index].praise }}票</span>

        <div
          v-if="item.is_praise == 0"
          @click="bdbtntp($event, index)"
          class="btnta2"
          type="button"
        >
          <span>投TA一票</span>
        </div>
        <div
          v-if="item.is_praise == 1"
          @click="bdbtntp($event, index)"
          class="btnta2s"
          type="button"
        >
          <span>您已投过票</span>
        </div>
      </div>

    </el-carousel-item>
  </el-carousel>
   </div>


  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      bangdandata: [],
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      if (JSON.parse(localStorage.getItem("userinfo")) == null) {
        axios({
          method: "get",
          url: this.$apiUrl,
          //  headers: {'content-type': "application/json; charset=utf-8"},
          // timeout: 1000,
        })
          .then((res) => {
            let a = res.data;
            this.bangdandata = a.data.hot_course;
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (JSON.parse(localStorage.getItem("userinfo"))) {
        let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
        let fas = new window.FormData();
        fas.append("token", tokens);
        axios({
          method: "post",
          url: this.$apiUrl,
          //  headers: {'content-type': "application/json; charset=utf-8"},
          // timeout: 1000,
          data: fas,
        })
          .then((res) => {
            let a = res.data;
            this.bangdandata = a.data.hot_course;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    bdbtntp($event, index) {
      //获取点击对象
      var elf = $event.currentTarget;

      let id = this.bangdandata[index].id; //作品ID

  //let grid = JSON.parse(sessionStorage.getItem('grid'));//个人作品ID
      if (JSON.parse(localStorage.getItem("userinfo")) == null) {
        this.$confirm('请先登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({path:'/denglu'});
        })
      }
//       else if (id == grid) {
//   this.$message.error({
//     message:'自己的作品自己不能投票！！！',
//     offset:200
//   })
//   return false;
// }
else if (JSON.parse(localStorage.getItem("userinfo"))) {
        let token = JSON.parse(localStorage.getItem("userinfo")).token;

        let postdata = this.$qs.stringify({
          id: id,
          token: token,
        });
        axios({
          method: "post",
          url: this.$apiUrl + "/index.php/user/praise",
          data: postdata,
        })
          .then((res) => {

            if (res.data.code == 0) {

            this.$message.error({
              message:'今日投票次数已用完，请明天再来！',
              offset:200
            });
            } else if (res.data.code == 1) {
              $event.target.innerHTML = "投票成功 ";
             this.onLoad();
             this.$message({
               message:'投票成功！！！',
               offset:200,
               type:'success'
             });
            }
            // elf.style.backgroundColor = "gray";
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // 作品详情页面
    bdwk(index) {
      this.$store.commit("zuopbtnId", this.bangdandata[index].id);
      if (JSON.parse(localStorage.getItem("userinfo")) == null) {
        this.$confirm('请先登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({path:'/denglu'});
        })
      } else if (JSON.parse(localStorage.getItem("userinfo")).token) {
        this.$router.push({ path: "/ptson" });
         let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
   if (rzstutas== -1) {
        this.$router.go(0);
   }
      }
    },
  },
  computed: {
    bangdandatasan: function () {
      return this.bangdandata.slice(0, 3);
    },
  },
};
</script>

<style>
.bangdan {
     height: 8rem;
     margin-top: 0.8rem;
}
 .bdtop {
    /* width: 19.2rem;
     */
     height: 4.62rem;
     background: #152e56;
     overflow: hidden;
}
/* 标题 */
 .bangdantit2 {
     text-align: center;
     margin-top: 0.47rem;
}
 .img1 {
     float: none;
}
 .img2, .bangdantit2 > h1 {
     display: inline-block;
     vertical-align: middle;
     margin-top: -0.27rem;
}
 .bangdantit2 > h1 {
     font-size: 0.32rem;
     font-weight: bold;
     color: #ffffff;
}
/* 列表 */
 .listcont2 {
     width: 15.4rem;
     height: 9.35rem;
     margin: 0 auto;
     margin-top: -2.67rem;
     overflow: hidden;
}
 .kelist2 {
     width: 3.97rem;
     height: 5.21rem;
     background: #ffffff;
     box-shadow: 0rem 0rem 0.51rem 0rem rgba(0, 0, 0, 0.11);
     border-radius: 0.05rem;
     position: relative;
}
 .bangdan-img, .bangdan-img > img {
     width: 3.97rem;
     height: 2.67rem;
     cursor: pointer;
}
 .kelist2 > p {
     font-weight: 500;
     margin-top: 0.32rem;
     font-size: 0.21rem;
     font-weight: bold;
     color: #000000;
     line-height: 0.26rem;
     margin-left: 0.32rem;
}
 .sp12, .sp22 {
     font-size: 0.16rem;
     font-weight: 400;
     color: #767676;
     position: absolute;
}
 .sp12 {
     display: inline-block;
     height: 0.34rem;
     background: #f7f7f7;
     border-radius: 0.03rem;
     left: 0.2rem;
     bottom: 1.37rem;
     line-height: 0.34rem;
     padding: 0 0.08rem 0 0.08rem;
}
 .sp22 {
    width: auto;
     color: red;
     right: 0.35rem;
     bottom: 1.46rem;
}
 .toup2 {
     position: absolute;
     right: 0.8rem;
     bottom: 1.41rem;
}
 .btnta2 {
     width: 3.09rem;
     height: 0.59rem;
     background: #0265bb;
     border-radius: 0.05rem;
     line-height: 0.59rem;
     margin: 1.12rem auto;
     text-align: center;
     font-size: 0.2rem;
     font-weight: 500;
     color: #ffffff;
}
 .btnta2s {
     width: 3.09rem;
     height: 0.59rem;
     background: gray;
     border-radius: 0.05rem;
     line-height: 0.59rem;
     margin: 1.12rem auto;
     text-align: center;
     font-size: 0.2rem;
     font-weight: 500;
     color: #ffffff;
}
 .btnta2 > :hover {
     cursor: pointer;
}
/* 轮播 */
 .listcont2 .el-carousel{
     width: 13rem;
     height: 5.51rem;
    /* border: 1px solid red;
     */
     overflow: hidden;
     margin: 0 auto;
}
 .listcont2 .el-carousel .el-carousel__container{
     height: 5.21rem;
    /* border: 1px solid rebeccapurple;
     */
     margin: 0 auto;
}
 .listcont2 .el-carousel .el-carousel__mask{
     width: 0;
}
 .listcont2 .el-carousel .el-carousel__item{
     width: 3.97rem;
     height: 5.21rem;
    /* border: 1px solid forestgreen;
     */
     margin-left: 1.2rem;
}
 .listcont2 .el-carousel .el-carousel__arrow {
     border: 1px solid royalblue;
}


</style>



// WEBPACK FOOTER //
// src/components/BangDan.vue